// import { info, Browser } from "./Browser";
let uitl = {};
let _Browser = null;
let Browser = null;
let info = null;
Object.defineProperty(uitl, "_Browser", {
  get() {
    if (!_Browser) {
      _Browser = require("./Browser");
    }
    return _Browser;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(uitl, "info", {
  get() {
    return uitl._Browser.info;
  },
  enumerable: true,
  configurable: true
});
Object.defineProperty(uitl, "Browser", {
  get() {
    return uitl._Browser.Browser;
  },
  enumerable: true,
  configurable: true
});

let ua = navigator.userAgent; //取得浏览器的userAgent字符串

function checkBrowser() {
  if (uitl.info.browser === "IE") {
    if (uitl.info.version === "9.0") {
      return "IE9";
    } else if (uitl.info.version === "10.0") {
      return "IE10";
    } else if (uitl.info.version === "11.0") {
      return "IE11";
    }
    return "IE";
  } else if (uitl.info.browser.indexOf("Firefox") == 0) {
    return "FF";
  } else if (uitl.info.browser === "Chrome" || uitl.info.browser === "Chromium") {
    return "Chrome";
  }
  return uitl.info.browser;
}
function bin2hex(s) {
  var i,
    l,
    o = "",
    n;
  s += "";
  for (i = 0, l = s.length; i < l; i++) {
    n = s.charCodeAt(i).toString(16);
    o += n.length < 2 ? "0" + n : n;
  }
  return o;
}

let m = {
  lessThenIE(max) {
    if (uitl.info.browser === "IE") {
      // let arr = ["IE6", "IE7", "IE8", "IE9", "IE10", "IE11"];
      let currentVerseion = parseFloat(uitl.info.version);
      max = parseFloat(max);
      if (max < currentVerseion) {
        return true;
      }
    }
    return false;
  },
  parse: function (userAgent) {
    return new uitl.Browser(userAgent);
  },
  // 是否是mac设备
  isMac: function () {
    return uitl.info.os === "Mac OS";
  },

  /********设备********/
  //是否是pc
  pc: function () {
    return uitl.info.device === "PC";
  },
  //是否是移动端
  mobile: function () {
    return uitl.info.device === "Mobile";
  },
  //是否是平板
  pad: function () {
    return uitl.info.device === "Tablet";
  },
  /********系统********/
  //是否是ios
  iOS: function () {
    return uitl.info.os === "iOS";
  },
  //是否是Android
  Android: function () {
    return uitl.info.os === "Android";
  },
  //是否是Windows
  Windows: function () {
    return uitl.info.os === "Windows";
  },
  //是否是MacOs
  MacOs: function () {
    return uitl.info.os === "Mac OS";
  },
  /********浏览器********/
  IE: function () {
    return uitl.info.browser === "IE";
  },
  chrome: function () {
    return uitl.info.browser === "Chrome";
  },
  // 360
  360: function () {
    return uitl.info.browser === "360" || uitl.info.browser === "360SE" || uitl.info.browser === "360EE";
  },
  //safari浏览器
  safari: function () {
    return uitl.info.browser.toLowerCase() === "safari";
  },
  //qq浏览器
  qq: function () {
    return !!ua.match(/mqqbrowser|qzone|qqbrowser|qbwebviewtype/i);
  },
  //是否是微信打开
  weixin: function () {
    ua = ua.toLowerCase();
    return (ua.match(/micromessenger/i) && ua.match(/micromessenger/i)[0] === "micromessenger") || (ua.match(/wechatdevtools/i) && ua.match(/wechatdevtools/i)[0]) === "wechatdevtools";
  },
  wechat: function () {
    return this.weixin();
  },
  // 是否是 cardova
  native: function () {
    return new RegExp(/DreamSoft|DreamsSoft/i).test(ua);
  },
  //是否是钉钉打开
  dingding: function () {
    if (dsf.client.iOS()) {
      return ua.toLowerCase().indexOf("dingtalk") > -1;
    }
    if (dsf.client.android()) {
      return ua.toLowerCase().indexOf("com.alibaba.android.rimet") > -1;
    }
  },
  //是否是专有钉钉(有点虚，不敢保证)
  govDingding() {
    return ua.toLowerCase().indexOf("taurusapp") > -1;
  },
  //返回小程序客户端类型，如果为null则不是小程序
  miniAppType() {
    let clientInfo = null;
    if (ua.indexOf("AlipayClient") > -1) {
      clientInfo = "alipay";
    } else if (/QQ/i.test(ua) && /miniProgram/i.test(ua)) {
      clientInfo = "qq";
    } else if (/miniProgram/i.test(ua) && /micromessenger/i.test(ua)) {
      clientInfo = "wx";
    } else if (/toutiaomicroapp/i.test(ua)) {
      clientInfo = "bytedance";
    } else if (/swan/i.test(ua)) {
      clientInfo = "baidu";
    } else if (/quickapp/i.test(ua)) {
      clientInfo = "quick";
    }
    return clientInfo;
  },

  //是否是钉钉、微信、政务钉钉、企业微信、小程序中
  envHide() {
    return this.wechat() || this.dingding() || this.govDingding() || this.miniAppType();
  },
  // 是鸿蒙
  harmony() {
    return ua.toLowerCase().indexOf("harmony dreamsoft") > -1;
  },
  //是否是安卓
  android() {
    return ua.toLowerCase().indexOf("android") > -1 && ua.toLowerCase().indexOf("linux") > -1;
  },
  //获取浏览器指纹
  getFingerprint(domain = "www.DreamIT.com") {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var txt = domain;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "tencent";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    var bin = atob(b64);
    var crc = bin2hex(bin.slice(-16, -12));
    return crc;
  }
};
Object.defineProperty(m, "info", {
  get() {
    return uitl.info;
  },
  enumerable: true
});
let _type = null;
Object.defineProperty(m, "type", {
  get() {
    if (!_type) {
      _type = checkBrowser();
    }
    return _type;
  },
  enumerable: true
});
export default m;
